/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Course,
    CourseFromJSON,
    CourseFromJSONTyped,
    CourseToJSON,
    Office,
    OfficeFromJSON,
    OfficeFromJSONTyped,
    OfficeToJSON,
    Teacher,
    TeacherFromJSON,
    TeacherFromJSONTyped,
    TeacherToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeacherProfile
 */
export interface TeacherProfile {
    /**
     * 
     * @type {Teacher}
     * @memberof TeacherProfile
     */
    teacher: Teacher;
    /**
     * 
     * @type {Office}
     * @memberof TeacherProfile
     */
    office: Office;
    /**
     * 
     * @type {Course}
     * @memberof TeacherProfile
     */
    course?: Course;
}

export function TeacherProfileFromJSON(json: any): TeacherProfile {
    return TeacherProfileFromJSONTyped(json, false);
}

export function TeacherProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeacherProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teacher': TeacherFromJSON(json['teacher']),
        'office': OfficeFromJSON(json['office']),
        'course': !exists(json, 'course') ? undefined : CourseFromJSON(json['course']),
    };
}

export function TeacherProfileToJSON(value?: TeacherProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teacher': TeacherToJSON(value.teacher),
        'office': OfficeToJSON(value.office),
        'course': CourseToJSON(value.course),
    };
}


